export const pt = {
  CANONICAL_LOCALE: "pt-BR",

  "general.send": "Enviar",
  "general.cancel": "Cancelar",
  "general.apply": "Aplicar",
  "general.name": "Nome",
  "general.privacy": "Privacidade",
  "general.recipients": "Participantes",
  "general.message": "Mensagem",
  "general.toFilter": "Filtrar",
  "general.messageSingular": "mensagem",
  "general.messagePlural": "mensagens",
  "general.messageSettings": "Configurações da mensagem",

  "date.shortYear": "ano",
  "date.shortYears": "anos",
  "date.shortMonth": "mês",
  "date.shortMonths": "meses",
  "date.shortDay": "dia",
  "date.shortDays": "dias",
  "date.shortHour": "h",
  "date.shortMinute": "m",
  "date.now": "agora",
  "date.today": "Hoje",
  "date.yesterday": "Ontem",
  "date.start": "Início",
  "date.end": "Final",

  "filter.filterByPeriod": "Filtrar por período",
  "filter.filterByProcess": "Filtrar por processo",
  "filter.filterByRecipient": "Filtrar por participantes",
  "filter.clearFilters": "Limpar filtros",
  "filter.filterByFlag": "Filtrar por marcador",
  "filter.searchIn": "Pesquisar em {name}",
  "filter.numberOfactiveMessages": "{number} {sufix}",
  "filter.noMessages": "Nenhuma",
  "filter.allActiveMessages": "Todas as mensagens ativas",
  "filter.allActiveMessages.sufixForLabels": "mensagens ativas",
  "filter.allActiveMessages.sufixForLabels.singular": "mensagem ativa",
  "filter.archivedMessages": "Apenas arquivadas",
  "filter.archivedMessages.sufixForLabels": "mensagens arquivadas",
  "filter.archivedMessages.sufixForLabels.singular": "mensagem arquivada",
  "filter.allMessages": "Todas as ativas e arquivadas",
  "filter.allMessages.sufixForLabels": "mensagens",
  "filter.allMessages.sufixForLabels.singular": "mensagem",
  "filter.messagesOpenedByMe": "Abertas por mim",
  "filter.messagesOpenedByMe.sufixForLabels": "mensagens abertas por mim",
  "filter.messagesOpenedByMe.sufixForLabels.singular":
    "mensagem aberta por mim",
  "filter.allFinilizedTasks": "Apenas tarefas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels": "tarefas finalizadas",
  "filter.allFinilizedTasks.sufixForLabels.singular": "tarefa finalizada",

  "chat.messages": "Mensagens",
  "chat.settings": "Configurações",
  "chat.chatSettings": "Configurações de mensagem",
  "chat.userNotFound": "Usuário não encontrado",
  "chat.typeUserName": "Digite o nome do usuário",
  "chat.typeMessage": "Escrever mensagem...",
  "chat.mentionUser": "Mencionar usuário",
  "chat.sendTo": "Enviar para...",
  "chat.optionalTitle": "Título (opcional)",
  "chat.archiveMessage": "Arquivar mensagem",
  "chat.newMessage": "Nova mensagem",
  "chat.newChat": "Nova conversa",
  "chat.noDescriptionTitle": "{archived} {name} e mais {number}",
  "chat.noDescriptionTitleNoOthers": "{archived} {name}",
  "chat.archivedPrefix": "(arquivada)",
  "chat.optional": "(opcional) ",
  "chat.noOptionsAvailable": "Nenhuma opção disponível",
  "chat.newMessagesReceived": "Você recebeu {number} {messagePlural}",
  "chat.noFlag": "Sem marcador",
  "chat.flag": "Marcador",
  "chat.task": "Tarefa",
  "chat.flagFinalize": 'Finalizar "{flag}"',
  "chat.finalizedPrefix": "(finalizada)",
  "chat.disabledUser": "inativo",
  "chat.someUsersInactive":
    "Alguns usuários estão inativos e não receberão as mensagens",
  "chat.allUsersInactive":
    "Todos os usuários estão inativos e não receberão as mensagens",
  "chat.fetchActiveUsersError": "Ocorreu um erro ao buscar usuários ativos",

  "chat.fileSizeExceeded": "O arquivo excede o tamanho suportado de {maxSize}.",
  "chat.fileTypeError": "Formato de arquivo não suportado.",
  "chat.fileEmptyError": "Arquivo vazio. Selecione um válido",
  "chat.attachmentError": "Falha ao enviar o arquivo. Tente novamente.",
  "chat.attachFile": "Anexar arquivo",
  "chat.viewFile": "Visualizar arquivo",
  "chat.viewError": "Erro ao visualizar o arquivo. Tente novamente.",
  "chat.downloadFile": "Baixar arquivo",
  "chat.downloadError": "Erro ao baixar o arquivo. Tente novamente.",

  "chat.newChatFileDisabled":
    "Você só poderá enviar arquivos depois de iniciar a conversa.",
  "chat.cycle": "Ciclo {number}",
  "chat.chatEvents.OPEN_FLOW": "Abrir fluxo",
  "chat.chatEvents.OPEN_FORM": "Abrir formulário",
  "message.empty": "Comunique-se com a equipe",
  "message.empty.description":
    "Escreva mensagens para tirar dúvidas com alguém ou com mais participantes.",
  "message.error": "Ocorreu um erro no sistema",
  "message.error.description":
    "Não foi possível carregar o conteúdo. Por favor, verifique sua conexão, atualize a página ou tente novamente em instantes.",
  "message.noResults": "Nenhuma mensagem encontrada",
  "message.noResults.description":
    "Modifique os filtros ou escreva uma nova mensagem.",

  "privacy.public": "Pública",
  "privacy.public.description":
    "Enviada aos destinatários selecionados e pode ser acessada por qualquer outro usuário que possua permissão para acessar o processo.",
  "privacy.participants": "Participantes",
  "privacy.participants.description":
    "Enviada aos destinatários selecionados e pode ser acessada por qualquer outro usuário que tenha participado do processo como responsável pelas atividades que estejam em execução ou já aprovadas.",
  "privacy.private": "Privada",
  "privacy.private.description":
    "Enviada apenas aos destinatários selecionados.",

  "settings.inbox": "Caixa de entrada de mensagens",
  "settings.sendMessage": "Envio de mensagem",
  "settings.notifications": "Notificações",
  "settings.dynamicMessage": "Filtro dinâmico de mensagens",
  "settings.dynamicMessage.description":
    "Sempre que navegar ou clicar em um processo ou atividade, as mensagens vinculadas a eles serão automaticamente filtradas. Os filtros ainda serão aplicados normalmente.",
  "settings.alwaysOpenNewMessages": "Sempre abrir novas mensagens",
  "settings.alwaysOpenNewMessages.description":
    "Ao chegar novas mensagens, elas automaticamente serão abertas em uma janela.",
  "settings.pressEnterToSendMessage": "Pressionar Enter para enviar",
  "settings.pressEnterToSendMessage.description":
    "O envio das respostas em uma mensagem serão feitas pela tecla Enter e não mais clicando no botão Enviar. Essa opção não modifica o botão Enviar na criação de novas conversas.",
  "settings.receiveEmailNotifications": "Receber notificações por e-mail",
  "settings.receiveEmailNotifications.description":
    "Passar a receber notificações de novas mensagens por email.",
  "settings.receiveMentionEmailNotifications":
    "Receber notificações de menções por e-mail",
  "settings.receiveMentionEmailNotifications.description":
    "Receba um e-mail sempre que for mencionado com @ em uma mensagem.",
  "settings.more": "Mais configurações",
  "settings.notifications.description":
    "Escolha entre receber todas as notificações ou apenas menções com @",

  "error.reconnectingIn": "Reconectando em {seconds} segundo(s)",
  "error.reconnecting": "Reconectando...",
  "error.connectionLost": "Conexão perdida",

  "tooltip.close": "Fechar",
  "tooltip.newChat": "Nova conversa",
  "tooltip.moreActions": "Configurações",
  "tooltip.moreOptions": "Mais ações",
  "tooltip.searchFilters": "Filtrar",
  "tooltip.clearFilters": "Limpar filtros",

  "profiles.manager": "Gestor",
  "profiles.last-approver": "Último_Aprovador",
};
